const gali = {
  name: "Gali",
  position: "Developer",
  intro:
    "A skilled Web3 developer with an insatiable curiosity for new ideas, and a kind friend to everyone he meets.",
};
const bella = {
  name: "Bella",
  position: "Developer",
  intro:
    "A frontend developer who loves life and coding. Embracing Web3 has opened up a world of new possibilities for me.",
};
const donny = {
  name: "Donny Du",
  position: "Developer",
  intro:
    "A young capybara in the team, but a cool buidler in the crypto industry, WAGMI!!!",
};
const richards = {
  name: "Richards",
  position: "Developer",
  intro:
    "I have been working in backend for 7 years and have been involved in both web2 and web3 fields",
};
const jerry = {
  name: "Jerry",
  position: "Developer",
  intro:
    "Weaving Web3 dreams with code, forever curious, constantly exploring the infinite possibilities of the blockchain world.",
};
const lily = {
  name: "Lily",
  position: "Developer",
  intro:
    "A curious web wizard, playfully exploring and treasure-hunting in the magical world of web3",
};
const alex = {
  name: "Alex",
  position: "Developer",
  intro:
    "The only non-Web3 guy in the room, but passionate about startups, new ideas, and exploring new opportunities.",
};
const nj = {
  name: "NJ",
  position: "Developer",
  intro: "passionate about hiking, diving, and coding.",
};
export const Introductions = {
  "1": gali,
  "2": bella,
  "3": donny,
  "4": nj,
  "5": richards,
  "6": lily,
  "7": alex,
  "8": jerry,
};

export const Introductions_M = {
  "1": gali,
  "2": donny,
  "3": nj,
  "4": bella,
  "5": richards,
  "6": alex,
  "7": lily,
  "8": jerry,
};
